export default __webpack_public_path__ + "static/media/cooperLeong.8ef00110.png";